module.exports = __webpack_public_path__ + "static/img/tishi.151a3525.png";